import axios from 'axios';
import { EventBus } from '../event/event-bus.js';
import router from '.././router';

const apiUrl = `${window.location.origin}/api`;

const client = axios.create({
    baseURL: apiUrl,
    json: true
})

export default {
    async execute(method, resource, data, accessToken, ignoreSuccessNotification) {
        return await client({
            method,
            url: resource,
            data,
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        }).then(req => {
            if (!ignoreSuccessNotification && (method === "post" || method === "put" || method === "delete")) {
                EventBus.$emit('emit-success');
            }
            return req.data
        }).catch((error) => {
            if (error.response) {
                if (error.response.status === 403) {
                    router.push({ name: 'Unauthorized' });
                    return;
                } else if (error.response.status === 401) {
                    location.reload();
                    return;
                }
            }
            EventBus.$emit('emit-error', error.response.data);
        })
    },
    async getReportLayoutsByName(name, includeTemplate, accessToken) {
        return await this.execute('get', `/reportLayout/name/${name}?includeTemplate=${includeTemplate}`, null, accessToken, true);
    },
    async addUserReportLayoutChart(id, chartId, accessToken) {
        return await this.execute('put', `/reportLayout/${id}/user/chart/${chartId}`, null, accessToken, false);
    },
    async addReportLayoutChart(id, chartId, accessToken) {
        return await this.execute('put', `/reportLayout/${id}/chart/${chartId}`, null, accessToken, false);
    },
    async addReportLayoutColumn(request, accessToken) {
        return await this.execute('post', `/reportLayout/column`, request, accessToken, true);
    },
    async removeReportLayoutColumn(request, accessToken) {
        return await this.execute('delete', `/reportLayout/column`, request, accessToken, true);
    },
    async addReportLayoutRow(request, accessToken) {
        return await this.execute('post', `/reportLayout/row`, request, accessToken, true);
    },
    async removeReportLayoutRow(request, accessToken) {
        return await this.execute('delete', `/reportLayout/row`, request, accessToken, true);
    },
    async updateReportLayoutColSpan(id, request, accessToken) {
        return await this.execute('put', `/reportLayout/${id}/colspan`, request, accessToken, true);
    },
    async updateReportLayoutTitle(id, request, accessToken) {
        return await this.execute('put', `/reportLayout/${id}/title`, request, accessToken, true);
    }
}
